export default "__VITE_ASSET__DaEtO6VV__"